import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'

export default function ReadmissionQueryPass1() {
  const { oid } = useParams()
  const navigate = useNavigate()
  const [configValue, setConfigValue] = useState({})

  useEffect(() => {
    document.title = '查询结果'

    axios.post('/c/retention_admission/config/get', { 
      merchant_oid: oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setConfigValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [oid])

  const handleReturn = () => {
    navigate('/readmission/query/login/' + oid)
  }

  return (
    <div className='result-page'>
      <div className='application-progress'>
        <div className='application-progress-currentNumber'>1</div>
        <div className='application-progress-name'>初审</div>
        <div className='application-progress-line'></div>
        <div className='application-progress-number'>2</div>
        <div className='application-progress-name'>复审</div>
      </div>

      <div className='result-icon'>
        <img src="/images/chenggong.png" alt="" />
      </div>
      <div className='result-title'>初审通过</div>
      <div className='result-description'>
        请在初审通过后7个工作日内，按照下方提示信息将纸质材料邮寄至上海杉达学院招生办，并自行关注复审进度。
      </div>

      <div className='result-info'>
        <div className='result-info-box'>
          <div className='result-info-label'>联系人</div>
          <div className='result-info-content'>{configValue.contact}</div>
        </div>
        <div className='result-info-box'>
          <div className='result-info-label'>联系电话</div>
          <div className='result-info-content'>{configValue.phone}</div>
        </div>
        <div className='result-info-box'>
          <div className='result-info-label'>邮寄地址</div>
          <div className='result-info-content'>{configValue.address}</div>
        </div>
        <div className='result-info-box'>
          <div className='result-info-label'>邮寄材料</div>
          <pre className='result-info-content'>{configValue.readmission_mail_info}</pre>
        </div>
      </div>
      <div className='result-button' onClick={handleReturn}>返回</div>
    </div>
  )
}
